import { ModulePage } from '~/components/ModulePage/ModulePage';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ModuleSlotId } from '~/modules';

import { RiskCockpitHeader } from './components/RiskSustainabilityHeader';
import { modulesConfig } from './RiskCockpit.modules.ts';

export const RiskCockpit = () => {
  return (
    <ModulePage
      header={<RiskCockpitHeader />}
      modules={<ModuleSlot id={ModuleSlotId.MAIN} modules={modulesConfig[ModuleSlotId.MAIN]} />}
    />
  );
};
